import { Component, OnInit, Input, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/auth/auth.service';
import { DataService } from 'src/app/modules/new-dashboard/pages/data-service';

@Component({
  selector: 'navbarinst-dashboard',
  templateUrl: './navbar-dashboard.component.html',
  styleUrls: ['./navbar-dashboard.component.scss']
})
export class NavbarDashboardInstComponent implements OnInit {

  isCollapsed = false;
  isFirstMenuVisible = true;
  isSecondMenuVisible = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private _authService: AuthService,
    private dataService: DataService
  ) {
  }

  ngOnInit(): void {
    if (!localStorage.getItem('sidebarCollapsed')) {
      this.isCollapsed = false;
    }
    else {
      this.isCollapsed = localStorage.getItem('sidebarCollapsed') === 'true';
    }

    this.onResize(window);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (window.innerWidth <= 768) {
      this.isFirstMenuVisible = false;
      this.isSecondMenuVisible = true;

      this.isCollapsed = false;
      localStorage.setItem('sidebarCollapsed', this.isCollapsed.toString());
      window.dispatchEvent(new Event('storage'));

    } else {
      this.isFirstMenuVisible = true;
      this.isSecondMenuVisible = false;
    }
  }

  isActive(route: string): boolean {
    return this.router.url === route;
  }

  navigate(route: string): void {
    if (!this.isActive(route)) {
      this.router.navigate([route]);
    }
  }

  toggleSidebar() {
    this.isCollapsed = !this.isCollapsed;
    localStorage.setItem('sidebarCollapsed', this.isCollapsed.toString());
    window.dispatchEvent(new Event('storage'));
  }

  logout() {
    // Limpiar cookies
    document.cookie.split(";").forEach(function(c) {
        document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });
    this.dataService.ClearDataService()
    // Limpiar almacenamiento local
    localStorage.clear()

    // Limpiar almacenamiento de sesión
    sessionStorage.clear()

    this._authService.signOut()

    // Redirigir a la página de inicio de sesión
    this.router.navigate(['/login'])
  }

}
